import React, {useEffect, useState, useContext} from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {useTranslation} from 'react-i18next';
import { useHistory } from "react-router-dom";
import {CurrentUserContext} from "../../../../contexts/current-user";

import Layout from '../../../../components/layout';
import useFetch from '../../../../hooks/use-fetch';
import Spinner from '../../../../components/loader';

import DivisionSettings from './settings';
import Persons from './persons';

const DivisonEdit = (props) => {
  const [currentUserState, ] = useContext(CurrentUserContext);
  const {t} = useTranslation();
  const [itemId, ] = useState(props.match.params.id);
  const [loading, setLoading] = useState(true);
  const [currentItem, setCurrentItem] = useState('');
  const [divisions, setDivisions] = useState([])
  const [persons, setPersons] = useState([]);
  let history = useHistory();

  const [{response, isLoading, error}, doFetchItem] = useFetch(`/directories/divisions/${itemId}`);
  const [{response: personsResponse, isLoading: personsIsLoading, error: personsError}, doFetchPersons] = useFetch(`/directories/personnels?division_ids[]=${itemId}`);
  const [{response: divisionsListResponse, isLoading: divisionsListIsLoading, error: divisionsListError}, doFetchDivisionsList] = useFetch(`/directories/divisions`);

  const [{response: itemUpdateResponse, isLoading: itemUpdateIsLoading, error: itemUpdateError}, doFetchItemUpdate] = useFetch(`/directories/divisions/${itemId}`);

  useEffect(() => {
    setLoading(true);
    doFetchItem();
    doFetchDivisionsList();
    doFetchPersons();
  },[])

  useEffect(() => {
    if(!response) {
      return;
    } 
    setCurrentItem(response.data);
  },[response]);

  useEffect(() => {
    if(!divisionsListResponse) {
      return;
    }

    const list = [{label: t('without_division'), value: ""}]
    divisionsListResponse.data.map(it => {
      list.push({label: it.attributes.name, value: it.id})
    })
    setDivisions(list)
  },[divisionsListResponse])

  useEffect(() => {
    if(!personsResponse) {
      return;
    } 
    setPersons(personsResponse.data);
  },[personsResponse]);

  useEffect(() => {
    if(!response || !personsResponse || !divisionsListResponse) {
      return;
    } 
    setLoading(false);
  },[response, personsResponse, divisionsListResponse]);
  
  useEffect(() => {
    if (!itemUpdateResponse) {
      return;
    }
    setCurrentItem(itemUpdateResponse.data);
  }, [itemUpdateResponse]);

  const onUpdate = (data) => {
    doFetchItemUpdate({
      method: 'PUT',
      data: {
        data: data
      }
    });
  };

  const onPersonClick = (id) => {
    history.push({
      pathname: `/staff/${id}`,
    });
  }

  const headerData = {
    title: currentItem?.attributes?.name ? `${currentItem?.attributes?.name}` : "..."
  };

  return (
    <Layout 
      headerData={headerData}
      isWide={true}
    >
      {loading ? <Spinner/> : (
        <Tabs
          className="text-gray-800 font-medium text-sm mt-4"
          id="default"
        >
          <TabList className="flex items-center space-x-4 border-b-2 border-gray-200">
            <Tab className="px-2 py-2 -border-b-2 border-gray-200 cursor-pointer" selectedClassName="text-blue-600 border-blue-600">
              {t('settings')}
            </Tab>
            {currentUserState?.applications?.staff ? 
            <Tab className="px-2 py-2 -border-b-2 border-gray-200 cursor-pointer" selectedClassName="text-blue-600 border-blue-600">
              {t('staff')}
            </Tab> : ""}
          </TabList>
          <TabPanel>
            <DivisionSettings 
              currentItem = {currentItem}
              divisions = {divisions}
              onUpdate = {onUpdate}
            />
          </TabPanel>
          {currentUserState?.applications?.staff ? 
          <TabPanel>
            <div className="pt-8 pb-10">
              <div className="flex flex-row justify-between items-start">
                <div className="flex flex-col mb-4">
                  <div className="inner-title">{t('division_persons')}</div>
                  <div className="text-xs text-gray-400 pt-1">{t('division_persons_text')}</div>
                </div>
              </div>
              <Persons 
                tableData = {persons}
                onPersonClick = {onPersonClick}
              />
            </div>
          </TabPanel> : ""}
        </Tabs>
      )}
    </Layout>
  );
};

export default DivisonEdit;
